/**
 * Challenge submission entity – one video per user per challenge.
 */
export function createChallengeSubmission({
  id,
  challengeId,
  userId,
  videoUrl = '',
  voteCount = 0,
  createdAt = null,
}) {
  return {
    id,
    challengeId,
    userId,
    videoUrl: videoUrl || '',
    voteCount: Number(voteCount) || 0,
    createdAt: createdAt?.toDate?.() ?? createdAt ?? null,
  };
}
